import { render, staticRenderFns } from "./Fold.vue?vue&type=template&id=fbd790fc&"
import script from "./Fold.vue?vue&type=script&lang=js&"
export * from "./Fold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports